import React from "react";

// // // //

/**
 * CoinLogo
 * Renders the RWA_COIN_LOGO as an inline SVG
 */
export function CoinLogo(props: { className?: string }) {
    const { className } = props;

    return (
        <svg
            className={className}
            width="420"
            height="420"
            viewBox="0 0 420 420"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M209 15C157.37 15.2648 107.953 35.9945 71.5849 72.643C35.2172 109.291 14.8683 158.867 15.0006 210.497C15.133 262.128 35.736 311.598 72.2911 348.06C108.846 384.521 158.369 404.997 210 404.997C261.631 404.997 311.154 384.521 347.709 348.06C384.264 311.598 404.867 262.128 404.999 210.497C405.132 158.867 384.783 109.291 348.415 72.643C312.047 35.9945 262.63 15.2648 211 15H209Z"
                stroke="currentColor"
                strokeWidth="26"
            />
            <path
                d="M210 15V405M405 210H15M59 90C103.073 121.442 155.861 138.342 210 138.342C264.139 138.342 316.927 121.442 361 90M361 330C316.927 298.558 264.139 281.658 210 281.658C155.861 281.658 103.073 298.558 59 330M195 20C167.212 43.4679 144.879 72.7166 129.56 105.705C114.241 138.694 106.304 174.628 106.304 211C106.304 247.372 114.241 283.306 129.56 316.295C144.879 349.283 167.212 378.532 195 402M225 402C252.788 378.532 275.121 349.283 290.44 316.295C305.759 283.306 313.696 247.372 313.696 211C313.696 174.628 305.759 138.694 290.44 105.705C275.121 72.7166 252.788 43.4679 225 20"
                stroke="currentColor"
                strokeWidth="18"
            />
        </svg>
    );
}
